import { render, staticRenderFns } from "./TabMail.vue?vue&type=template&id=81319a04&scoped=true&"
import script from "./TabMail.vue?vue&type=script&lang=js&"
export * from "./TabMail.vue?vue&type=script&lang=js&"
import style0 from "./TabMail.vue?vue&type=style&index=0&id=81319a04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81319a04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
